import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Plaster = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="160px"
        height="30px"
        viewBox="0 0 160 30"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g id="tape.psd_1_">
            <defs>
                <rect id="SVGID_1_" width="160" height="30" />
            </defs>
            <clipPath id="SVGID_2_">
                <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
            </clipPath>
            <g style={{ opacity: 0.2, clipPath: 'url(#SVGID_2_)' }}>
                <image
                    style={{ overflow: 'visible' }}
                    width="60"
                    height="320"
                    id="Calque_1_2_"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAFACAYAAADgax98AAAACXBIWXMAAAsSAAALEgHS3X78AAAA
    GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAV3tJREFUeNrEvelvZGl25vfGwmCQ
    DO77Tua+1tK1dXWXqtRTGKklDTRjGLYHNgyMP/iL/x77mwEbBoyZkQ33jDySNVJLvVaru/bKrNwz
    mUxmkkzue5AMBiPMSD8P31/ciqxuGRZM4BYrgzfufZfznvU556Sq1eofhRBSJ1fvydVxcjWdXOWT
    61if755cMydX28k1cHLtn1wtJ1fh5Mro3pSu9Ml1dHItn1yHJ9f/cHKN6hm1vz0/uf7i5Hp6clVO
    rgNdzXrfcz2vqs9q78nqbzf07LP6dzH8Pz8V/Tutq/bvPY2zSc9o0nOu1v6zdHKtnVyXTq73T67x
    k2vr5HqmL21rEK9o0rXP+0+ukZOrVRNt0u+cBlV75qYWsTbxJ7qnNonva5K1zxf1t8GTq/3kWtei
    FnRvWc+p/fRo4WvjXNCEq/r7PBYg6POgMVWxIanahFf0hSZ9KaPftc9X9YXaKr2hQQyfXN1aySsa
    aEYPzOj+kibVrgGt6h21702cXGNa8bO6p0t/qz3/jH7Xnr8jaihrfJ/qu/9SE6ptxk/1+ZY+29X3
    2rXj29qoGvVeyWoXq/pdI8Uh7Vy/Bll7cZ8meqC/9ep3n3Y1+dOsFwa89JZe2i4yb9NCvq7F3dek
    s9iZ2ucPTq78yXVeE6/9XDy5Ok+uRyfXzZPrvzy5pvS32r9/ooWtje3hyfWDk+t6bU5ZkdO6Bv/d
    k+ttffHHIp2qVrVF5PdQg7qk3y/7qYhsj/XsEV2XNbGSnt0t0i7pHWl9/wATqi3QqzpWK1gQn9/a
    +N7Ud8v6TlkTHtNRrb03l9V5CXpZn3aW5yOlF2ZBqmWc2+RPFVdGO3lJu9uts5jFgMoiwV0tkJ9x
    KN5So45JPSuv52UwvkONJa059OqIbOkojYoaXhy79EsGncJNJUxuTUypEwyr0U9a383pasLnae3K
    viab0U49ElMyVaxp5481iRa913zhCDs4rP9Pi4r6wa23dX8lgHySO5TWLmRBOus6T+ua6BHYf0kD
    q4Ccy3jmoe7zPbXvbohajjTpPYmeHb3Tuz6hq0XfXdTC7GryZ0U5Gb2rIGbaq+Nam8MdLeBxFiy8
    qpfvQ2wMY3cegdN+Le7ZrQe36//zWizvfFaDzGjQbSB3U8GKJlfQbqyI7Gv3ntOgR/SsQ41jSfcM
    6T2kttr3Loici1rIO2JqXVnIr9pE72tnVvT/eU3mkeTvmlZ6US+30tGlwWf1m5P2QprBeectzpb0
    91Et5IwmWRvotPhKAdQ4p3vG9P0mcHYfxwlR3ZEo8lO/h2KpjP9v0+odakEG9eLaIK5KlHSLRI91
    Zlogj/ljptTUYLIWWUfaTSssj3V16tkm14zeU9VEPoNc509ei1UVJXb6+GQ1uZR+X5VYquqM7Gpn
    n4s02yUeXteq7mvXmxqIqComX9LvNX1nWpMtaALTOItrGvCSJtiO3e0UuT4UF97Rd5LvLeudOZG7
    /13M6uFmYM0a5KoG1qPrqc6vye8Y5NSmfx+CI25rAV7VANb0/CY9exhncgQ8IKPvH2ixtzVoL1wO
    lHegBcuCAoLGsiSm2KIJT+hZu0naT4tsv9IK/qG+kNO/05hYR2IFa1ral1AFTQ3HEG02JPa0EKua
    cJ8G3qzBr2KyB4nda9e790WREwnqOtJxeCKKqC3QNZ3943QD7ehIO7IJPbqkHbYl9FgDPwYnLmtB
    OkXyb0MftpLRIeOgrGf8nX6byeU1eXPXkBBvx/r+uN7brfszWBDr30sa60ONu8YL0o1Uw6JWdViT
    tRLSpXN2TavWAbIs6u+/pwHm9b0DcdT70rZSGuCiyLGswb2C5xWwqN3ayZTes6MxjWgHt6EnWKHZ
    EzkH3f9M465NeiHbQMOq6oFnRa7H4qAV/b6YUPCPRS5dYj5ZrHZtMvfEUc3Rt7X6Be1Wc4LCcrp/
    XZOa0Viq4DdNYKi2AzzhDX2Whwq7p993GmlaBZ0Nk00a56s9IXoqOm+3ZGgcJc7boSZwASbhnOR6
    7ec1LWBTwo7dBj/Z0nObYFxsiEpWRA0lnF/zhyZtWG2X7+rf1XSDHW7SirUm5Ohj7cx+QoVc1WSf
    wSb1y7f0/SFdFU14W89MaxFLEB0bGrBNyWZoawH3+KhVwNgsOkfEzKa1gYv6fqHRGZ4RNy3ATFsS
    eR7JcvHOFzWB5xJPh3ANbYthHGiXD7UAd3XvIsj0CFRzoM/OgHkd4fjsiqkO6uwPQ121RjetBW7R
    fMrawA7q0ua0dzXZPphhOa3sfU2wIErY1jmrwmNR0eB3RG7DMC1XtHD9eqd15BUtQqsWJatjMKv3
    5BKGSFZH7oLGmYd6XNLxsZ49pM15wWPsIDPLP4LSYBJv0aC7ZM3sagBVkday/taqv/Vo0lvaoYIm
    YwZC511OC3WYIOmKuPqIBpxN8I1ukHw7NoZ2cV7PG4LScpkkndEOdSYektVngxr8JryTZlJ9MPnG
    NZlVrGwOIqhZOzyMgR/CW3GkQU7iWOWwUPar9WtSVGHzuu+Z/r9Vk3+uxbhMtczG+RlMuKQJlsUE
    7mjQ63rQCs5cl3b0GGZeJxbSz2sXZz6nZzbpvn0wK0sEq60ew6Le06tJb0CK2Il4ICUpp7NckZFR
    25Rr2QbWzSB06qLIdEkDuAq3Sg6MZ1h/n4Vp1qlJjetv1pIGdM85LIhl7w6o4TNNpAvHokUTsrxe
    03NbNKZ1jbkoyTGkeWyZihpx6WHselkvmpHX8KqYVlEvKcJNYw/hqCY5BavIDoVmKRFTmojV0l2R
    3TYWuajFaRVfMOk/xNHb1Pc6NMFteFOL2uksZHs128B5bXOxpJXJizuPi5Rs5mWxIz6X/VIqpnRv
    M0RXVgPpERkfQi20xtSmv/Vr4J3Q0Kzjl6DaTomsV6XROToyJmfCYz3HCk9ITvgIXHtFXHkSHo5t
    vbRTC7GlSfi6YKsE3v4tWV/muI42TGgwBS2OlYiq/l0QZfw9lIxdUZMtOFtZs6KkTS3ytDbjAN7S
    UUcejqHBPBVJ92pgd/XQY5D5lnZjTyKp9vtXIvt9/e7RAK/qnnXozL/RIk7AcTCivz0WafbBgtqS
    87ALnNwy3GbrrN5titzTO5c02VfEm1JZ+KDLmPyqSHMRq9Snc5vDTvuBC/p+jQpua3WviNyONTFb
    TjsafDPcPBlR16F2aVm72JzYwWFtzBm4em+BYvxs++DmNNF3OOE0AmEZccdZkbN3vUO7VpCH3xHE
    78hcnNKE/ly7tKfPWmCT9kF253U1wX2TQsTQR6tZ13NtSisUjAONw0doUBsRJD6XwcQ6zZuyUNtS
    Win7kIs6c7ZmejXIc3qYfcKjGuQGxFqNo3+gHfkb7IZlc48WNwPtqQjvZQGfd2nBi7CNOyBzSxpb
    N9zAW1BY9uk1ySZWeEhf2tKN17WDaZhwLVq5LZHWABzzPWIYA5CP7fp8V88chjGRg0Swnn0Zbl8z
    vwLe3w757TNrx/sZHbUdeCoPRAVXqV1ZtbS6tqGXXNBqnsFu7IpEP9MLfRYXRCE2NPY0YC9KBgpD
    M4Lp9m19LkbThDDJoc5iWWPr1vN6IFkuiOp6RR12QF6SeMprXJmkWLJPaRMOsFEtSA88Cg5U+wzR
    0hoQlezqGY7UW+FvFw8Y1N/WNZB7ul7X8828Cron6PtjOkbe8QtwLmYQZ+6HLvBLLd5uUvFwXLcD
    ArwTZyHANdsOF4pt2D3t7G09/L4ceRc0kT3dZ2a2pKs22E+0k99HnOkp1MecvnNZPKUFvvQNLQ4N
    iWlNOoWwS+2+UiNNa1s7eh0WShNIsgRH2YwmsK0JrkNGnpFTb1jkPq/frfpsC1x0Tc/M6rfFYhHG
    /hCOQwobYCo41L97ddnoGANzK2UhyIsiq4cayBlNaEQ7bTXxiRhMgChrFuO4pMF1gcHUXvqFfNaH
    2pXXsYB3NbkKtKNuPe832ohBaFpHCcnSps83tFHn9Z5faCGuiSpyJuktPdQIm129cAPO9l2t0JoW
    xG7W8zjfQzoGHcB5HEomfiZRltcCL2kXn4uUN8V4RvS8FmhlOS3gc0QkWhL6gw2XHTCqNFTeMStA
    WTjkCooUBDjAytqddT20E0J+UoM7QqRgEN6QiiZyU8/Y199XRLYp+J1HxcwmRBVV7F5BR+AOzNFK
    Qrq06bOHQCwMwcc16Gdm9QJrOeMit5ReYJ25IBI/o5V+qN1tw062wtxLAw00IyoqaAeP4ANzRPGS
    JlyAvpzRzqREEaaGf9bA02rc2LzeNSmKeYqx5U3SdqjXHvZXesmEPrusnW6DJ+JAZGJbtQj71GKo
    VQP3mesWt6xx4Y9lDFzWxLoFiZpCJGND5t09PWMFsIVMA+SCNTWHdbyR5gsGv2xloRLuSSN5pl2+
    Crlawe5ZxewU17XGlNfDm3GGNvXZsRbujJjUFkRaL6jD6udtQY9K0NQ+QCSkUXiIPrSSFmoTKmvt
    ezPZhAs0pZs6cT6skVURo23X4D7V2X1N5NqRiBUfAOw2JlK7osEsiAy74Kq1q7dV7+gXac7odxu8
    LBx3TufUuI4tnfdVKEm1uT3IAkCWhOq1Q5cNwFVlEUaZE4m2iCQzCI+WtBgHiOHeEJluyKo6rwVM
    iZO/A7cqfWIPdI5fT2wEPa6MOq5qATmG2i4vJp14DqTxnBASEaD/7mrQN2F+tSZCIA9135Dus1gp
    QMmwn3tJ9xsnlgO4xR7LUQTW+OMFLiJM2gcGaLzHC6Z1lDj8HbhxV0rBqgbXih0uigvu6VzmYBxc
    0MKtwZwbhc9qXUfHgbIJ8Yt5Dda8ogfQiG3xlw5cpqhVxLOf67hM6P839b4Xvu4sIm8BDGFLq30P
    mKgUVv0cGNeU5PcbMOAn9fcbItvfP7n+SN+vLdS/F2NyTLhF5/cTke8WZPCONKUv9N2/FwO8BmPn
    c31nTDtrOMQ+1OHae84nJ2yvQgmhyGeayKD+NiW5uamJDkvEXNLuFWCvTsE12wkNKgMvSFVUsiOK
    +Dvd964G2aNneANsdk5q9+c0zp7EzluL3BPlvEAmNeLSeei5Bm6e1+Aei6u2aHCtiCv14izbOTgM
    IEwG+Mt2xKaeaND3Ecge0CK1YFz9opgAZronsj0EVqRJm3OIY3YamjVsiRO2I87YiwsaoMMsU1qx
    Q62yIwstYDJBAzFWshUvPhIFmU/YeT8I1+5ZBNF29bx+RApHNDEzvTaASPf07K2EEjLs+HC2AeSn
    Q4M0qPRzLUIGTKCiF7fg3zbdKmIyj+ANXUHAuoygeVoaWJMsqlVRVTOYY1YTHtQYRgBqS0tJ6k4A
    YB4DBTBl3GXSAXAEpOotqImLOqdT+iytB0wgTmzPhtW8Z5r8Y/mtn2jXCjoOfaKQ96SBlRDitMJA
    h8SKxmWXbI+evawFKOi7GXhMAhx8WRsPSZ30GQBkg+CU+3r5NLyDDpobteqQ6RfixBYzK1qwff3t
    mSbbAgego4hp6MEV6AktmuiCqHAAKNlpyOZWWFAOqHXRa7mfIOkK5OAPNOFf6t4JMbAtcHczCQPH
    jd8YNszg5HpLA/xYk/u+du+GjsMu1NIDKCglxLuaEcrZ104/A0IhaLG7gL6bRdw4FRAQI0lvQ5cd
    1dn5QvLxmZiUXbBlDdhRe3PY97Wy97QYoxpks9TDKTG1L8C0xsDEnGkzroEH2LXvahyzesZ55GPM
    aXc79DxTaIY7XE2QdL8+H0OMaFDkYyumRnZ/oBcZxrAPf5aRQBu6/oN2659BaSkDPvz3WrjHeo9d
    Sf9UCz+tc/klkk5uIKpwE0dnTHPq0viK+lvny+LDe7rRkJ8UPBF7kpfWatrgh76ne18FCdqsnBRP
    qMD2/lyTrSCQfU0KzK4Wrfb3j+CUqMB/VRKlvAbLrIRwjsOsn2lha9TSeiqWUqlU9eRnWU6AH+jF
    dwAcbdOkr4ic8mAqeZGgI3/Wyg70sjOa6H14OL/UgNrh676o996FEuFUIoNT1/R9x4ivagHmgCcp
    Iahu3XrfEz7E7h5IBG1rIna89csA7xHZ2D6dhNbUp/O3AaBLFY6FBfizuhGcG9L3Sgk8Vm2w39MZ
    LSGU42hiN8RcC2JITZD7QZQ4QqZVbiCLcxIjOZzzfZ0xp+X1JcAqfSHmDE2J7D+WdjaqXfIZe1P/
    7tTzP9JAH2pwZS3QOqIUz+DR2NfGdOK8TujY5EJ9/uOE7nvBa9LwboREYHwX8KR9vfyXsH8tK5ek
    pPxGLynLH/UTHQnLbstdo9hfl5gpSkno0DtuaIIGpRcBdHPs+TBBtimEYB3fngX6qMWqJhO1yKln
    FOv9UDuSA+R+TjvtKGJtEL+WGnkYYuZojUn8c0UwxsXUDEAt6zMjdy4nIoyGUzzR0Ukh1uwA3kVA
    HozzfqaNuKmzOygxaZI/Sp7hAB32EeDAz/CwqnZwV2T1iSbwPrBbWe3gCDAWZ8XBvcgmvQH9v10z
    awCVBWhhE5DlA/osD33fWa1F6QxN+GxKVLSY9HjYl/SOVjClXXHG5q520PL4QPf/Cxn59oJac9qC
    a/UICojDl44JDWtAj4AgcGC8ArfROfjEjA7oQ4RkXKS8I25f0vPaRB0LjYBpViH79WA7wxyBsLtn
    QDtnj0crIu5NQNtk9Flt1X+k/38T8IR2YLNbgYO+GGKmq21zU9SWKKgCldi+q4UQU3WXJeLKYmyL
    dSQtWbykyb2jB32sld8ViXZpQkYG3BKjMQTRKQQXYVxY3fsFIvd/rZ19H46BawCnToGz7yLs81D/
    /319Pw9z9IlIuBlwxjT85vONNK19kYWhv+/IkHiqFSe8d1eT+BSQ/ip08BzcvrVF+i+0A3+l5y3q
    vrc00akQkzorwnc1aRxtIvtdxK+HcP5nEQNr0rO7QXm1+59mk5587bJJ0C5Zx4dGNFHnBA9rcjbS
    B4BgtXz22T/QgNf0PYPJc/BNZ5CfsAYzclr3PNb9ozoKHv+WuHIGx2AlxJoFZX1/otEZDjDCO6AT
    H4ucL2mF25D9shZi8mMLNKz7Wqw0Qpx9GoyRBBuITxmj5cTOJxrwD5Dz0A2n/xpkdEBotKhj1o6o
    Sc7h0r3arp66LatVhyknNfEKnOlngHjr1SDOI1ieAljFAbEHQAv5rN4Wyb2pRV1CDHdfu/VU77+j
    3/uATJxFMMAYzF2Q7gYgT1NwV7U3Ui39Y6i+I4Zn4cC7p0F0A4bUEWKCl8XYAw2+HfK9C1GLMxJn
    uYSPy2Had+EBcTbMZTgXAoyROW3E5RATugMc9bUNaXuRnlPbVe4yVnNCuzaiye3oi3k9ZBHx2E59
    1hZiZvaK7v1DUYSdcl8ljs0YoIcZOCKGpbfbj13Uc4ydroSYNm9FoygxNy7KeQYIR0s21CdK+adD
    CJyLOkdtmuyvNcGmEDNLKxqYoUnOv1/RBCc0aEf7H0GGlyBzK3rPvAZorasQYvJVM1zBKaAP1mB9
    OYPlnKjLjrza5+V0wi8d4Ag7A3R8syZhZd1ZYw9DLDwyLKbRDlmdQzQgD9v6ghA+BX3fMeQNeC+K
    wH/c1oJcRRpRSs+bB1arDUifPjDJSSspL0ItCXIOwCs+0uo5mdpI912R8APovUx4TAGjYcV+B5pb
    Vgvaqgk9RQSxWZqbcdS3NOFRSYhCggFuwM2UBsU6wtEEFbeQ9Fr6Z1O6cg925HsikwNx316tnu3O
    IiCLHlAeoNU9LeDXEEnt4PZOpHxb3xmHqbmCMA6rRDyGY2EA6mUV2MwK7OsXcjjzEqa1iThTp86Z
    TTiHT86GWK3F1o5hDwvQfD4SpTivdwSKgys55JCMcQRL5zls8lQijHsfqT0ZuHdTCN22Qer83ssU
    jy7JV7ti09C5MwhS9WjweTCx+1rhOYDOXExoGW6YbX3vmXb5snhCRYuyFWKy1lNoa/bD5SF3J0Vd
    2zhSWeBNHFtOv4xL281qrWtJImgAO76HNJsKxNTP9HKjYkfh+/oIPrK9EJOoHCGYA3R5SM6DVRkN
    VT3fZ38U6J5OHKM2gNaqEKUpa1qtLzEg7sBHvaHdmhTHHQbyrRmhjXYEy/ISRx+Ki9eYz081uBLs
    405RxhYyX4bxzFshZqxtaIEKOh73NeEeAG2KAOIci6p85qvZBngJejAN2b0j7aoPCLcj6LBrIvmU
    zL0tkdtUiHUC9sCs1qHQT4sL78kys6PuECLQYdKH+nuvqCUjqjPZr+OspwCOrTAFoJFq6YVIA5a7
    DFyGQdtjIdbZyEHH/Vrf69DgDQc2YK1fAzUTtNO/DR6YXi1oCaHRJX2eRjThHai8T+HWbQbvcXGV
    7WRsiSS9qAk812QKCJxtIRzjCVUQsizBAlrEYAfEnGw9uRrSK3rPlq4NfW4rh0WKjPPyBD8EACaI
    H2xhMTdggr7AaTU1mPCuVnBRu5pFDoHhCBZZzhA3jtrnyTIyrYV5Vfdf1GePdDxeg/jIAFDzVAtl
    CPAxDIlDXcahuOpSL4Dnhjy3w3Scb+TECzDODVIZhFgw0wqQiev495D+7nP5fZFdVYCVDiAMnMew
    pMXp0cCdFWfvxlua/JzG2xxirv8uLLcebdKiSHtIC70oWf8Ca7lOpUMeD2MqrojUHiOHIADCa1x0
    j0jH1Zm6MKkeAF0uaRDtQNxl4fw3+W2IZHs12Ws4RuYv53GsjoBACFpAb86kxvQirzkJW7IDoEkq
    3oeCK/wKMNxN7X4V4ZG0HuhScodS9Oeh2BQkVzN41g4Qf8cSfUbRu/7eazrPXYAQ7moiAR6PJ4Br
    7Oj/2xH2rV072Qa4RQ/uO3roPM5TGYhXw5Y+0v0/AKSwWS+6oTO/A8yycwInIDacmH0fpuZhAi5s
    hNGSPKmz+tsFGCnHmKB/hqGApLIIQySd8YMhprPZ4D+G2uZInvN+J/XwY1g+XwPi1A/IUjM4qycx
    B8d+HibpL0XSa/BM3tV3/1iU2CnyPSsDpx1U0yKHQy0oXzH3XW8QbnH0rypyLQLkaVLZ1cDnpBG1
    SQlYUnDNsKUtLcageEEfMJdfCQGQ0T2dWpg+hGnMY5xhntdEXsFupvS3Xr1vHhHNf3Ny/Y81CZEF
    2i1pDz+Hky6IjA9xhscAJL2lF9zUgvxGxyCLsz4pjplDoPpvxbnbgSuxHj2ud9kTaqVkGFaZXcc2
    Tff1HNf/2sO/XwTqXsjhBuahvZVjEhc3tPK2cmwidmjX+vXQItw/To3fgUunRZH/O5rcLeQ/jIqy
    qCg80qL8ATyj8/p/h3xc2q6I6MOyeITFmLl3NonEI3zJNu6SVrkfltWaHtwPnLSrIdm7OSIx9JMQ
    KyU+V6TiNvzYo7p3GAkkn+s9D+Gt8C4/Q4DNSNn5ELPD0yL1RVlZKwG1+76t8ug9PWAy4QFMAXfx
    inbvA+30UYjVU0whw3C274VYnKAApF1JDO6RdqUaYuLXuBbT1GSkzxhwmC4jdUUMrkXH6wkwnC/0
    82yDDBEHnmZCTFC2Er6s/++Gc8CK+SA0s1HtzEGINXqewlMyhck4nWAxxMy0MnDSznMYkJHxhSbS
    rHv2IHt9NKzbL4OcX6Qq1Xk8pHT0yQHu7DR7Jq06FsT6z2px7oSYBtcLpaGE89asnavtwJ8inJnV
    Oa5oZ76SGFqQg9Cc3RZdNwIDNkiONaZjQC6aAKGYp/qcbZAW0yn9t1dRQSdxGRmzHWLSsjPFrusc
    Lut8PtF5bNUuutjQNRgCFn+fiOm8H2Kq7I/hxD9AqkAawbpNLfZ3Q0wDfKad7hUVdetoOm/jxYS3
    G9jCls/2VtoG/bV2/FD/n8GLvgqxJuU6PImjulzOZizE1FoXCVoOsUDB95B2sA94hIErRvXOwV6+
    CI3wud7rjJjnUJ9fFBDbbiCSUsAnT+u8ufzMc4mpB7BY1jTBu0De2PBuFSlPAHy6ADyXDfa7Idav
    tdNhAXpwFUfqAsIpxmn3h/pKFYMh5jP6s0ojv3QGcIUydspR9uda3VGdlSZgmcdEsl2a+Lwmdh4g
    0RVx5AOZjdMamFH4KWDFXKncYs9l3F0nvhfAc+cypiHG3tBcPvWCZV9iCz+W8eAY8KwG/1BfNKke
    avW/F+pTXNu1OJ+KXGcQJJ/Xbh6FWGD7AvTkZpDyeb3HgXXXmc8BDeTS7pYoq1CAjLI95ct1blrZ
    whtSFgy//YUG76KY72kHV7XitnOrAIu6TFufdtN18GwVzWrCPjJn9IxiQqNrB9zRNrS7BTjHYglx
    6U3p5QWBXvIhlrt6AWmsDazjZJKrmqyDX44U9kjXzYuLnguxLk+ndiClHbQ7tD/UJzPb8PgcZ30t
    1NfKGpbyYojRlviE8yt6Ybzk9e8sfOTORRwSVd0Q2btElp0DpVPjQTK4ds7+0xCzvF1euSDOaI/G
    U+2M69V+Ikp5RwNZg9FgLeg5AuQZHZk3DOsNMdM7QDdYQLThqcYyoEV7Jirc1q6OawNWxDf24FNP
    v0wO9+hMHWpg4yLLTjEFA8c+A2TfZdTfDDFvcCaRErQAXIehSc7Vdy5FD2xuMsOHIv000L0utvsV
    EkwGJA2eShubA3a7S+P5BkC8pBt7Q8zJt/FvZf0pLBLHYscRJTQu2s6+FsScO6Uo9CCpw0p/kxZ0
    GR7KFWhxPSJvB9ay0OdbdWbbxA/uiwKMITG4JZV08Tgvvz/EPguTGJzT7ZZDrLDk0oyfwO1T1Et3
    pOnYGMggMjClI7QnUk/JdHwsP9aUmNsz3dMPJI8zYN/Vzrp6RJN2dTbU51DZFX2cTMUzYq4XATJr
    OA6BvKpdfqx7hpCAURSVtGq37uq77h+xJF3ZAe4jUdRNLdYDwPtTEGPHoIIUAGfT+CyDmFUzAmwp
    HNt9VnkIcFi/DszUCmScU2xG5dHc1SqP6Z7aYP91iFWbXEXtKowPo+S+0m9nmbfBAPgNeIwb5zh+
    XIYWV0HgzBbTUoj1r9PI23jBhJ20nDT8DfVZBcTXqt0IJnJDpNoJu9b+6gs6Q1dBrvNawHtiLN2g
    KOvlrsLmrLghDHgDHDwN07WKpA4H6J6FWHfvQL+3k35pp7q5QrdX6wjZKX2Izt0VafssluAFeV3A
    lS6tfFZMZw76thHrLtxrXPUaog6vI4pvj0YJMKUAWKPTfu0t+bmkzbw+y79wstl4EMbyCIr4tBbA
    TSjm4TVMQelf0m5Myj+9r5XeEnO7q8kuJ4yOJui/6RAroHmB2jSGIiRCHt6T80gLCsBjm7Tvw1Y4
    dfHsJbyV/dqVZTjPu5CZcl6DNBxwQS8YFXftBrD8J+DogxItr2jh8tKuRkQlHyNtqD3EjLIswGrH
    CJCVAHPYE1XuiS/May7nNMafGaKRjA873NGKXKUrIVYMdXMa183YByMaACR4RM/5Up9/V9zd1YF/
    qgG9pu8s628WPc5oW0NM2Eg9J6ashNgLwlHMJ1rUSYDR/ldIlCZbHK4hV1ToZFYM5x2AN3sSQn9d
    u/kWkAE7cChsixqmtbvndC4/1e66+86nEksd4vhTOn83MTYj7FNgTju6bOCPh1ijzzrEi+zWkyN7
    rCN7ajws6BzbH9wCEnfFkwEwnSYwmRZM0DnALhqW0uLNhJgLuKp7DmFedmlXPpCm9KpUXLuHHYNa
    1+I/DbHez2aIhQcnRZUuNlpMUHDuVJeW8dAjdKvjQA8kY8fhi/4VMJYjcAf1IOvkAs5xgMvmLQ1o
    SYtmW7oKW/xAz88g6P4Vcqdc5N6ZrK9rjO1wHriOR3PCVsgkNa0meDpsOBuC9Ne69vSgUTA4x42f
    6MVriE0Z0/W5nnkBpJnFDjtT5kvo0Xc1GVs75g/jsOC64BIqwzMzHup7PZ2qlo1CpVshJiaPhlje
    oklk/JqYmRWFJSyOmcmG1MuOENuQuL7dhM6XG8ldD7EixM0QS8PuwR62+voGFpiNayqIRBzA10Vb
    4TAZaimFWFqiQ+ftP4ZYps3Gwx+K9G0K3tAkbWw/CrFNYLMW0UqLW/7tgqxdeMyekUVYbrVd+5fy
    TE4jrecQR8FpPKtieF+JF2wkXDzLSSfeuvTYSyHWzCokMMctUPeczFyCwpICrMEN4PJSMbtCTOSq
    wIXTlFAYnsMP/bYkxhj8ZtsImLszwILk7WchVnBZTrihX3TjWYOmVQLi3b2NvqOJLCHHYEYrNwRd
    +7t66SN4FINWu02L2aHPmJFShZi5D7jTWS3weSwK+8JUwb1r3/tznf8hcXhDGLmhXaeKh7h0K8Il
    RTzQhbBbofHshVjx0A0aRxBOXYHSfoAFWEBAraqj4FpZBQ12LsQCoq4ocQT8ZhZUsaSQ6m3xgu/r
    u58a5oAJt5zGh2G+LQBVVwGZGQxqvfZAE3SxAntAWxJOvbf00h9q0D+TuKuR+v+hnXkzxFZHZ/Wc
    O4gaWuFx+fVj5GXc0BH4QIpLIcTkscEE4j9Xh4g/mXhZzOWNEFNdjZPYhkrZLHdtBYgA9zm1gjCp
    M9uD2M49gMkcWZzQRD4X+V7Xvz+CnVtGCsEOTELXq/4AgJnDELPQBxIS6IW1RC5mK+i2VmhA5Ozc
    /Flx7UPdOwRH+xch9gzt1UTctOZQ/ulVHYOzkJF/EGLytVuT2dGwE2LZdltWXlBH/K9CjJq59ksO
    D2m8/rmTRNMeINhdlYfxbQ2eqTu2Sq5Ao5oL9YX4bobYb8FB6cuS4SkBTR5qEf8zTcql4n4TYgr8
    bIj1Ocx9nWowDdxXB8TYpKwyZo3Xfm7ZL12CF8EOuzdEXoYHFqXZjMsPbDv3Y3FH69CHGuRT7VCf
    dOMOndXL4txlPfNrkWSfvvdLxIxduMQlMOwFuRBi9cUSYmC27s7Cx8UJV5LWkrtfvAexYS5chUv2
    5xr0rMSQDfU/0KL9Ry0SG92YwRxoQjbrbmq3/3P9exLpPtOiiF9Ih9+Ef6sdpN+mY/cmeIkz35oY
    SjrVpU8YVhNs0VYoEZ3wMe1AJNyGbTomLvuWFqZTO7cFnXlCC2CgWx8gvt49+7js+LNV5qbKVnzW
    QmwsZV36KMTOBd2IVlaSwe/Wk8mmpTM7CTkLfFTQw+d1vj4S03Di45+cXP9EpJRDBP413T8TYhNW
    4x/7dM97IVZ4cUL2vRBLwG0iirAPWe9auE7gLkJXt797TEfhfnLCzXDPfqiHGBPVEmJSViHE5KgC
    tJ71EMuy7iA6aJ14PcQSrPshJl66xW+3FuR2iElfC1qEdXhephC8m4cryOCVIy3IOJSVfy95Xjdh
    ei37dW5WtTKDUhLe1Er+UFrRr7R7RskvaHUduHqsXVlHhszZEFPajRSyr6slsVAme9e7c3JJS4gd
    Bywan2pSF0WdBSR4LDYi6XWgTb8IsXtGVdz4oQbvFNWBELvyuGBvL7hkC8IcDse4xt2QdqdVz50B
    VotjKYpbb+k5RhUY0GKx+EAbMxrqq6AaThWSaYbpUN+9w2WeHD4xx/u5zoMZTBV6rjFWTqnp12pn
    AOt3KXPXfXYMOA0PyIwYTrMWcRAOhiuisu+F2DpwXe+ckK4wGOob2jX8cUVAn4Ft7IDTzd0kzga5
    szXdrcdQBqcDuN3mD7QYP4cFZSDLcyzEOkBpr+sMOlN1S//+MMQSdOshFvu+EmKR/Sc4WjWl5V99
    24QDzuL/plU8D/Id00J8iYyTOdi10yHm5efh9lnX5NjKz62vm7XAN0JsUuX6AsZWjckgIADcxf18
    RLYQp3Id+t9vEDM7nbCjb30hpqs7T/gI53RCK2f3y1XBImYBNX4fzjTjn18NsQfSnRCbyWyEWLPu
    LIyNimR4KcSyNWVEFI8Bb7oPrIn//obcy20vm/BxIlTq4j85rbRFznntgDNAna1t2/UCYBIFeDP7
    4UB3fv9NTTgjajHE4qlI+EhM0EUJlzCmjhB7ifdD8fD4l0Lj3uinE7aRvgmt6II0J8dr2+DQaxMZ
    roTYDsiWTztQOD7/5qYuU1EGnHFajMg5UTMh9jQ0Av4h7t/Gjm9K7tp3nQcgbiPEZNFvTNgukC19
    0ZWEXe/qAaKKW4DVHwG73IroHhWRv1JYxX0NnY9g2NMVMTeHZrOAJA0jdnUM6IMd9A/EbIdCrDru
    fotrCPuGlykeucQ5cvHOI4BCHuncvRZizefPtbIr0MMf676bCFy3hph0fTHERK6yFs4oPPeX2ISc
    drTfOUr3tTBnAEs8AEhtRp9Vk2h/OuKd3+CKR/uA904BedOiAfUjp2BWz/mxBm5g+Xndc1Pfcw13
    u2luwPf1GMByq7Xue9wvptktRunAvHtNbIqXLDo/KcTEzobI2QCv4CsiywcaiAHZ4zIuBqFQbOqM
    3UZwLCNSvagJPoFuXIKxbm/JTU1oVX8fEel3AaFzU1TgrJg9IHJLQB5c0UJOOMSa1LRI0k04x+4W
    uxli8yYDROYQzlzSijuD5T1pPW7DacyjGztW4d69KJKcA2c17KgfXNlVhe3WyYgq7oeYrmectVF5
    aS3gQaMdToMLLsEx1gN18Fg7+fcivVWAVga0QIUQs07ZBLkDoJchoF3bxAucRutSF69rcl9oAq4s
    7np8a/BhbcJ92wyFphkQjm9M2FBhV9h3AtWstJwhRP9dSCQNeP5VqKXm1L1wDlTko1pBLGkfGK8R
    uGNagMWq/f4RUoCcWjsgKTKjsXjSrfBZEz3/jQmbAfxxiBXIcqG+1HETPnM6bJ+smNcBQbwH+/k+
    wphZuHQyiAcVNPgm8Qz3MtwF0uCONDg3UT4Pv5qLnrwOG5jtSvKNJuxEqinAkybgnnERA4ctp7Xi
    mwCs5SWyNvW3WxpQsxSYSYDFCqCsAnTzdVFRt3aoHYj3UejnLglnA2Y7fLOOQT9MzYa6tDu9H+DA
    W9d9K8Rqou57NqKXryIk+lWIbYW2RZbGiuzgrGdCfaLVhp5Z1Ll16QpHHFdhAQ3AEzmGI8TzaiDb
    QWhQ3yALFfCBHu46PMtQ5K8Cjm9/sFE2P5XTflYTvKQA3AWRmznqBR2ZnUSKQSfALmkxsVeBIBrR
    Z3dFOWuIKPQD+xmAki9CInxjwq5PZUHeorP4QCT2N5KzfXqYc/DdBvQW8FAFgdHc6LgHsVy39TLU
    dwg+8AyMhi91z/UQC+0OwnE4FGJtLrc9+AogcedD9L1sh8+G2DrXCv2obrbHb1/CvwjVc1Q7P4I4
    bBl+6gpg/lZwHFey69XJzdkQU+3K0JCWRfI+2yMhdvAohVgQdBZZMZbXP3iZppXWzlqDuQNj3LkG
    l0Tud/TgDfitxrQwtqnXdZ8r9fdpsA9D7JVYhvgY1+LNQidIy1Ho/78EnxUtMbfndTfMJRzTOxrz
    Nya8hwCVc4oK0Kp6tJN9IRYxcMLHqL57DbgtZ3e73fWX0MryIRbIbUOU/owWztbXc6B2+zXhXn3u
    yi2uFtOGRJHnIZa1eNAgRamualEVnorbAFy7x1KLBuA6ec6HuKIVXgBk34mQ89LMDsEv3gkxr3E6
    xAoNreDgS5rAEQA1XXrn8xDLunZDCxxBAki+QTD8dMJD8Dpc0cuMqLkTYmJjL5jaov72WN91Q7hF
    IOXsgZgIsbXBE2lIr0EJaQaw3P1TN8DJ5+BMr4r6diFKHZV4FaCXYYjICCQ9MRWzCpUU4ABPa6Dl
    ENvnrYI5jGj388B6GGz6XOTujs6b+PzPddYzIfZNnEACh2W/jfgloOaf6B3TmuwzwKLsWMiFWH2t
    GhpUR3cw7WGIZRm7QmxXb7JwJlq/BnoL6Tn++9UQE6W3ENtxwuQuwi1O3HLRINecty+sI8ROPmdD
    LD5oV/AvNGa7h18VoOY8JMj+t9nDfyWZd0lf7gqxhnMLPCG7AGf7/LB38RZyj1zLpxvOuAwUA4uV
    2yHWs30vxNqYT4GI7dUELBlWtNDf05hHtThu4uzOA12hQXE0d7kZ1gr164uuYuYSEYYb2iXzgRbj
    qXbHCsBjGBa/CrH1gUvM7IiCDAZfBme/FmKjqT5RkxECD7UQ39GRmpKO7sZwBSy+Q6e5l+3wD6Ua
    LsiBPQ2rwylwayGWihkAcM3ceVPn6o4483kxqnshNqjyeRwOsWSNAauuUDyjmNJnIVYjdcExGybD
    sI4OEJU0zLAaYlmqhlw6F2Ih6rJI5awe2AlnmlPwxjTAfqTWPIFjbVvfmUSI5oF2/nqIpVxTIWad
    1X7+L8EnboXYEmxQO2bA6n2kGM2C+08CaGpUbu3zfCMn3rp2zJWQbBE5iySrHbFNWtu1v9RKD4t0
    b8DzeTHEwmIGqxZgpJ/Tji9qYsZj/W2IKbNXNAmbrQdyIpzXtQ9f9lfwfgxrE+ah+BhbdjrhSZGm
    84QNTLsRYodmm2tXtPLuXudkiwEAYqZ0XtsRcRgGhMLN2zYAE3ZRXoNfeuASugZG5LPeA1u+CKvo
    EShmI8RauXUTfltkeCfEZhCOv66FWCqiqL8faAcLob6jfEpMZSLEqqPfgRXFln1fh1jzeRjOdqcL
    WRHKYdFTob71ghH5buju9iR55GFM6DguUPFIATJ4jLhuQYvwU33RvqpLILdVoNivaRf3AVDtR0x5
    US92RqhL13wvxNZ+rip8Txsyhqj+EIJqbjLpSVVhb2f0Nxct+yypeDwGdnJAL3c5F8OWHNl3uZl2
    RPGmQixT7vrvTpczQvZZiHUw7Qq2O9cGgPMJU/rOCsCoV/SdEtJ3vgKV9IZYTt2+N6cNtSS59Baw
    TNPgtFvAWNkNOiiy7gU5uUj+KsKsdxE82w6xuJ+x0iVhulKIAl6GruyeS48R93Iu06qY1L0QS7za
    xVOBLDazSicnPCuyuCSOvaXz4xwkRvnntSApqZNTyI9wB45NJGrcC7Eu3Sa8Fj0Inwb40nyWxxES
    LcJtWw6xScUlZNwcQgnJhPqWwN+IPGxqlVLIO6qx/v9KZHegnWQBzx0xHqcLODJvyP8BeEM7Amh5
    nFXHmPPYvREdEwe5b2oRp0Ns1TkGbv+J7nXg3Lb8ABhvMTnhKYQW0zDvzulFSxqEa/K4GlIrREUa
    weoCvBx5uGTbpNC4NdBnyKHoCTGX6REc/ikg3Bl+2QuxL8ssjJQSxNU9GRpLjQLinyNyNxxiceoZ
    eSy6EIeqwkfcL9I27OkIsm8PQfYDuGWc/HVPEzA0+IaOkTsMjGuiWWSpHMGM7NBmPdZ3hrX7A3hX
    JaleZqESuufnBGzQz8Qt/1hkHTQZJzSOwzNShHO9EwCWLoC8HaEoh1h4zGVX93EsXLrGvZJ+DVt3
    SZO223gNSKDuEBMti7D26iY8bSxxiAUNHibOxHMAP7PwVrh1QYsWzrr2NBwIrrNlm9tJkW5LNoRQ
    pxWNv9V4WiEFXBrDVpnVRieJ2L3kGNYc8jLqJuxuV4757sMxdhUYqsUQe3UbVvgsxFR2d99ws1Xb
    si7IbeyXS8C5MKBLZgwhDPNDcPRuTXpTC/U1wK47wIbZhdsaYpHAUkiUwMtKKf9MA7+AFBkX0DRy
    7nqIRUkWgMh7BsXFLQr+VKTsVFk3X7bzLYczOCDya4eLtV/B91viIxdCLFGzC/hSGelGvbqvH/iv
    JjoBrFq6kO278joY0ufit84AfRJirv8/0QRN9vd0r0tDOeTJykk5UcdVDSaD4NoW7NgQYs1KI3I2
    Q6wQcRf+KzeqGZXePqXx/VoLex25EKc7fF3n7AMoCOPaGSPRLQsndY0BHLaGiXYCOfBMg9vV8zcA
    dXBD9SoCeu7x4DJR7np7qAW9C0R8u5wAozBkXK7O9SzfEz7zL5K6tMWLY60ulzouWXxX/54Qp07B
    s+AG52MyCQdxjpul767o+XNatMuA+fvYZGAXX0UKwI6ed18L9qFkuauvGKHvVoTuam0/3HAjXXoG
    vx0Ptm94P8RmFnf07x6AuysagFtqH2lSWzrDx9pNtzaxN6I3xPIV60DkPhVT2wSDdE5Dj4LnDpat
    A6N9F66lXu14V4ilbOomfFOMY17k1ieVjfWsXBTIsaLNEKswNYEb2owzAtd5g24X5DCmd3UG2S9O
    Q3gMp2EZ/rBFPMM6vevWu9/xG/r9RBpYKhluyQL7PAB85RcAtYwABH4WisQGRJZt2y7kES2D45YS
    CABjrWe1MPN69sUQS2pUIJIKiCsZgOZWgdM6bs44vaMJpyWmOhoxLTdkvKeb7V4Z1llwt9k2+K6q
    QNak4DRfxeXi3IMhJoCtI1pwqEVyTuHDEOvevaOQjKnQ1RanAb9ogf79eYgJZa672drIWnKTiH74
    hF0mxgq9J+BkZzvVuyTDn4nU3KXOpR0P4aEIkJ9tGEiXJrasHfdz39XvWZG99fKSyNyA9KcCoc/o
    3UbNb8sOeJCccEeIGdnXFEguaRLzeFBTiHXdy3DLuGLwKuzQq1rdEmSpQ6VntLCuUHoJzOYcAK/2
    dOYlXp7BKkuDKnYRVXQ7JJZ7Licn3CdHfLsG0wuosNNeZ2GnOtJnfMZ3AHhZBSbE8am8zuwBooUH
    AJC6NIbNzCK8oe1w87jgwRhk8TkpG+vwZfdrskELPCTt73TCd0KsFc3arwVpO/1a3b8NsWfwW2Jk
    Z+GId+fZHaTvOEXAaTqOA3fB4Z8DJqsZgLJZaWQ7WowJ3T8G3uCxuqfboIwQJ3TWjs5jOuOzkmF7
    sDxSUAjKMAW38eKrCF26PXZNyfgjfbYVYmUVBrp97ppg+DtK0AYD3z61oJ28GmIidRoqa8ACuWut
    O/+wBmYdSU+E2OXGlQRzcJK7oPa4Xvx7eth9LcYj/U4h7+Ae5HQPQiO7iDSeE1W52VQa2OicQqAZ
    +KrZMc/lIg1I7YAbNxvqm1OGZKjlusjtuRiJMRUDALTY19QnajgMsS2Ja+24BdhF6NsV6Nt7Iv0i
    og0erKsFT0sU0rR0utB9HZWNECtBDSEB5Qoihy7gPdgomNaFWI29Dl+LgY3i3j5w5w5NzKCVNfjE
    LoTY4PWenrcPHOWmNCJHEI7g97btamzXlibp1L/5EIt3X4QYTGmxDkNMy3f6b6kR9HBaE7Gq9pVk
    84f6UheM8G6gfNzcqQBc1cca/DntipPADPr+WIv7Xoit+phhYw+ou2OVQ8x2M8akL9TXrS4COVCC
    AbEFXnD6kmWRXxsQMM4ncnugNPTonhDTX531WQJssXam/zWQdJMAm6yB67s5XAuUm9vAZQ6AvN+X
    ZKggCtmJMx0AwUhDw3qBOTnh0hmXmMpKBts57grczghfRyC8AxyXnguj7gxHKIRYsXRa5D0M0Pg7
    OgZOK3DxL2OqTXHtMCAOQ32WenciFlbSM12PegpRif9a4u02A+JP4eNdhsO8Be6YEZ0ZZ6xUEMtp
    0s45QvBqiA3Ul0JsLNMEaPIeAN5uBnslxOprGXg0F7U4TvywmXmsSc5IvVyXI+MYAf2ad+a1k12+
    4wnbYX4bwGozkB59eRDpAa6fsQQUegtgEGYSk1AjWbDgIVRSw6S2Qqzyb0jxNsxSt0ppBtd2Jov1
    +J5Q36ahE4G1LM/wkmRer1bri1Df0Nwp7MZkpME4RkNMYnZFtRQiFcPIRZpDZGMCCkIaSgJ172OE
    YQYgvzfE+Fw98aJCQi4P24ncitBILLmM8ZvipK6TM6MVfgfWza52yZWT7GpxetxnIXaiDogRNwPk
    loMZOQcEbQqkvgXXrdvuPkGimNXNd4HPcs9iInrM5I7p0+rE+TgE7GgeUP9HIfbndhreJmBPzuTu
    0gJMAPJLXLSRtGvgyg6yF0KsaGwAahYB9qdA8n0friNXSNuHUVEMsSRzbbKH1KVbNUEf8sshVlNy
    MNyFMq+FWPFoCzhJd9Y4goxsCvVV0cxo2hCROBIHXRVzmQixu/wxUnhs3LwCZ0UzNKpiiD1d7oo6
    H4fY5afkAktZyEK7Nyv6zFCCFSBiv9Rg/huk3fistSLhYgc6sKHCiyE2acwm8h4+gQZWCrF4YBk6
    wATMS6usG3qPKxzeDrE2UAk2wFHSHg6I8PWKNEdCLGRyFVrUTIjVk1wgsIDz3QmUrgEqVRgZ60Dr
    HidiR5+GWADYPrXzIVYr548X2sWSHoTYsG4qYX39HUn6tlahG7gIegJH9eJxvMjs/hkcA1ZNF6Vl
    nYGZaeiSdWNHJdz2ryRg2pYGaofgaIPJstIwizaMiWN3YtFLOJqnO/wzkMV7GmgVXM41X21AvKFz
    ZqXioR5sQPdWiDXyWoDVokHgBRzCc39fizEaYiv7KgLanTBBbVc7fONc4y59ZlvcwPQ8z3AvIEDr
    IZaBc+rd9USkP6OzauN6Hplkl/TSa4AYruhZtxANfKxQSQF5Dz06h/2ARNS0o/89xJo710Ns/DoI
    g8Rg9EyCClxMMJXEWqYRr12DzA0IZ7rezW6INdsvakKfhVgs4VyIzaPcnuCGdmrQYkIM8AKgRS0J
    kIuvv4bvfEHMyxkwRej0TTA3i1BocskJWwnYl0g6B4FtV8ou4EQ9QMyPS/j3g7O6fJSj88swH7e0
    aOdCLI/eBGXB524F0cgzIRZYMB6rrAhhH5LDnD9h76bzrI7pm84iSctJUGdCrDy6IJJ5I8SC1m2w
    VzuAtRwFLH9Gxn+35GtBzLFVXs7zIdahbkqIqD0ckdr9/12IDdPdN9GFjXy/Obtbb9u/1QmMZ52m
    NY+chy6JoVVZII/B+fxSpvvsAbWzidQcB9btzv2uvn8u1Dd42wBzdI/EI7iYCnD5VuDVGIY0cdSC
    /Us3gREtcYddySEDrFYTYq7WkTeQFmdknStBHITY5C0rR5/7G/psjyIq6XPMiv67AMZ0AsKfT4i3
    SohVJG4j/yEFIyYNlfaFP41yOK3V2JZrx1CiOTCaMwB2mvNlYMn8n1q0rBjZO5qwdWfrwe7tsq6d
    Hguxh3gRlNKBDUhaPUbr5yDHp2DFsYRcEUG2OjdtO7z7jxElaNMgVzWRPsRjdyU2fHbGtVDGWThD
    /Ag4LHNtG/RO5xsIsbGbcR6pBtbdnqjIaX2XZfBnEbvKQOpkML862NJ1PexPQszYLmvlmDW2FGIX
    j0NBi59CJXXnqyISvMwhz0K1zMFSuoqUm0p4eVmZZcjzXfGEy9DCKFlcv8/VU5uoeFQRGzaMdxG6
    8WUxCMODHdcl7Lcn1NecNBr+CHjqsRALEpnBuY57Hm6ddIPdLQLmPyjF5lKoL0xUhOy2CsvKqHUB
    8Q4wopTE1HqIZWaq8Ce1a4CWy+8gYrCiHe8M9YV7jX/c13uuhZgcbYDo2yFmnrdh0ubMA9ABOoA8
    cHuVI6iSzfB4UgM7dcQ7g8QlYiaQjWbvhVFwhhg5e7sLUCXHhEa1IDsAnx2E+kTJXmBL5vScMpQd
    m4DOSu/H+XanzRUxyzVQmtNtWcXJruYXhTwX4et1FK8Mh3sAJstNVRfhGuoBKR6Cob0TYp8zl63a
    DrFIt3fhfSBu2CdmTzu9orEEWEd9oBojdgoI2DUjcF/7qVUgrxUXveWcgCw8CdN6CJOj2qHrbsHh
    l4YOW5PDfyfoQTuUlS0Y/AadtQPzPA1s5gN5T1xavbbrP0YiiRF7r0qs2dG4GmLXoEnY4gGempq3
    5F4WWIhNOLrtX3oicn1dE99B+OIAcq7GOf8d5O4AHPchEeDaRXgzBRKeB5TJYuqB3jmDs70r0TQf
    YrquPZ4ZvKOCRDJTR8rFhhaxgkfwBdkAMBrua53zBUy29oyPNLAx3fs6qMJtT9ZD7FCbCrEi8S4y
    1VzMwE1s7klsvRZiw6hdeDaXcOyWQkz47MNxuwS3UNXW0m6IBX62kDdwEef7fwmxLpbz+0dCbL/r
    EOlncOuEEBOfz4SYT7wPkMomdGWDvY39+EORbgb6QDN81yVESW6FWPD7OVy5v9FCLpppuXxLW4j1
    nC+H2JHKctFVl+zhfxZib7UPQ2wjtIrAdAoaUGeIhUjcfNHJm+5m6S4g7o47gGcUgHRPIzHLjGlU
    lFWUJrYA9IL//zgLy8Ytre+KzJsBvy+Im9qcc7vPOUT5PJgunBlqQCtSL2dCTKl11Rf3hDgH2GIK
    rqJWoHZYpNCbUYXD0G0Ex/TO5xr/TZ/hf6tzMq5JrAEw3gPYTztWe0eraLJvB/mOIFJhJ9pjGexf
    AlvVinNsBchQhl5ENbbh9mmG+GGrEi+2tbt9uHTf1Hv+LKhXixud5kNMSe1FpL8VZBmwa8fQdmY0
    0IsahKGE7pn0SM/rRTTSjv+dEMs+GtrfDxCrkbVpcOPtUF8bKC2m1QZMt9siDAL9W83C62Fd1Xjm
    AditNCWPYFQ/B+6idkb+ezG0kiypp9C2LoTYSeBsQg9ehpdyIwEWb9Z7NhGNKIbYtKIFQTyXeXW1
    GesTnxotnE3YmUXIx13Zx1ngM1yC7SGCbQaGX5HcNoBlTjv1msRENcTyrW0Afe4g+P0OUH1OAbTP
    yhH+TWTD2dXjwgn3kT7gphyfhFiCo5LF2XNsyJ0mOyCbi4loQhmBq1aQ7q+gvDi+PATf1wa4aKvO
    Y3eImaAbIbYv6YOLJwWU7X7CSHAH+jvAfNuHZvveSkjaXNjt6l1B6ViM7BKYVgUuoDYwjYD0PGtm
    hvfuiTIu6OW3AWc0w7PSHzTwbVBUMzYkg0lWAXZz2clzYoqPQiy77nfkbFWxApKViXaR4SDQeLZa
    3PXma2S1XBaMMAdu6VjtmURwugSkXg8wkDYYsjqDTp4+A7hyK7yQIcQiow7dPgixiK9DR7MQX0dm
    RHns7AFMs0OcsecJrekS8JDWfq4Dd3kNCHr3YCjr84sabA5pObMJ16otq00AWw+hKo4jpOtz/AxK
    0biORovQP7U5/mUApO+5HvwpXDlX4Ii7qZV7N2ED50OsxbMLhSAFVJxrcRidcy7UN1HdA/CUaIIc
    yPVBiKVfb2kSF6CcdCNkOgfX79kQ6wXkA/oP7yENrwUpbR74NqDD50LsNdoBDz8hC2ZCPgIuV9OL
    LJMUmEkH3LWtkPll8ZIeZMakwNDcPN3o3eMQm9L0AQrtEO8p572iBzzTTYb+LIZY1H4CyL1mRAm9
    SM5AfZZABxkQ8zjx7wDmUw31xTgdDDsQE3qiDbkWYsEiRixWdH4PgcoraiH24WlJeQJtIk17CUYB
    VboB+P8ZTT4NJeAQHNVFOt3+uh/ZYkbdVxP+qgAUbgpKx4bMTjeGnE54RswIJ4ArcW7ifSgmIwC+
    n3oFsiCFDHAfHfrsFuAEhyGWnlmEaGpVxGEc3DoAr5xFsCwHcMwRYr2pBNfeRgDvSojVw+m3TiPC
    OaKJu+nrNhC3f0avpXOGzmpC9kO7lON3de89wR5+BR3XfQu/g3jzMYyNCoyLLQTIF0IsLeMKEoYL
    N+mZ30fWS9Dn+YTvOgUm6DG7U8ExHATBurTzC9wJxzFjAzUtQsZDLKr5GUy7szInz+HByZKstHKK
    CIyVkAyWCrGHcTs0tgrCqRlMNtkC8BBAd+dbOS5lKnxxhp3zsx9ihYdZDaIbPimDUVog/HeRfjOC
    gQb6kZARYxdtGfbt1wi0mYtbvJzVcZqGbl3FWT8EUzoI9fXncwlEwOm5ykCEfKoHXNFVBh7K9T5G
    xS1ri/A3IdbscWvNFiDuOsB5+yC73atwVabkIDyXrgcyBtfPIcAzprI1xLB2oBMMI+ehigmfhlrG
    Qn1FhzV9sRMZJ27O6urEO6G+EZsL4/5YlGBMxishZm2n4bs2gu9miHn/WWhULpPeJKZVBSnbivsk
    xD6mRugzf2IfiKMU7WFbNrVV/mN4+1gwsxsuGSscy/Azu0vtV9pxG+yLSAvYBiLHoZke+aE6RJZl
    BN7N3AqJOJPbE/YCnGYq2Yb2uAFpk6EunYE7xR4/68fmem0Jr0cOTGdGXPyazum74gnuw5CHgmGM
    pWFObllWG9xPQsw1dm7Ted3XoYVfDrF0jgHgNh4MsNtAbkYGR/GYuvQicM0PRDZTIRbfbUp48i13
    je7ZACcf1Y7fCPX1KtmIxgVOWpC19hygNfuf10E97mlqJ4Xt7DVk3CxBp+hD8NwFEl44AGrayY90
    Ph+Ka7drV93NyjkRTYlddkiEcHyTsCuNui5WCav9GnAdQwCeTofYuugQ3hcDwh2rMjxyCy4h6+Et
    ALg71/hLff+UO+9pIP8tdtAGvT36k3C+WSV9V7Yw3bIpRBY6AQ3sVEjUTgdzVrfi7YJ5GJClcowI
    Zw7wpiqeY2PGCF07J56H2ICy09ZSsqx4Ci903OmOtCwXGrDveQ3pNs6PqMICmwdIxe4aV0dcg3Pf
    rYQ80CLgD+UEl0/BtHQX2w5YWRVcI1rklLTDVBYgzUpCczkCh/79EEtMVRF8zuByEQOnuG6G+s7T
    1swuAIM5iQhHBeDxm/Int0JzS2NCAcCWISgz+4hUWtR1QH9PZREWOYZCYHiDzarOEAsBulN8EQg5
    N2DeRqCtCrdNFgqHLZoqIoIOvTxXLOih3nkBoNIUNsKb4lr0zViAXEIFTSWTPLI4F8RfZgHDLcMB
    /kAD2wecoB1eRyvsWwhzOAv9sUI5czjLb2viM8B6NSHm5VZmuUS22TOYh034TiZ8y0+yh3gaUYi2
    BGMw57sUYvfnAPcua9a2hPoumFX4rJ+F2AvRNUL6kKPgZ8yEWHbS6fYDIVZjzMEi2wqxJmceMeEq
    KKISEpNN4UonTMcjIN3yYExmcDdCbEGWh03dCyW/R4syq8/elSg0tKlbisYO7OXaRH8RYkGjNvip
    OgD7rwInOg5IREkUY397JRu+/SeFMOgR5F0qEbGws6AlcXaaILMLCMC9osF9pUWahuF+AIVnXQB2
    e1KGsZAOwLu0Yw4RDI/LzaZczLP62yZchaHPs5pclIEEo3jZ4tUccv9ziNUh+qSEXECkw0zR7cr+
    VO93jeoF8ZFBZLk0hfr2KoYmL0ljbNfzU9mEj6nRjznoMRx5AV7FI4iCY7hgMgk3TBkLtixvxjV4
    PItQFB6JvLPypDhO1a7//wrceyvU94JZQuDN5e4OnBDy2yacgq2b7IlSgdNgC+aY+31bGWiC8r+D
    vAnXsTQ8YTXE/MZ+cGUXAhwNscKqK413gzG5Fdn9EEvaGDibItOq/hayTsPGzCQmvA1Q9irElGGF
    nYng+IG0NUMflrFg7nZ5RqRqMWN4sLEgju63AiC+hFCQfeXN2AhjSr5xhhvtdhY2aSVB6o4z2dtx
    EWFXFuG1F9LVTvc0kWWR79cImDcD2N0WYtarW3q7wYUrTHwVYmlWl7dwNy3b+241Vs3CKjlKBM7o
    JCeCvQWLs43EjmkNpIrfAQ71LPIkXA9vOcSsuCU9503kOaQVs3IxbaNxjcS/H2I/B0MjreExSN6q
    3a7re7iHYLZJrRXB540QO9114Wx3hVhAO5OgFtujdrsao2mf9bhyIjo0+A+lebVBHF7SplzQhG5C
    b28FAqgTO+wmzE7+dlQ0lQVjYRetDpHrJ2IEjhmN6ny9CoddL9TTRlaXU2w6RREf65lDAJwYgvgK
    XLb+yUMyHIgKRvTurRBribjBhXOm2kIsazXl51qpT8H9mgKn7dTg7ok5NYfYSNFC3r1JVwG73w2x
    cZzdrltw5DtIZpSeS9z0NuApxwjjuu5XKzyhDusYQz0BHuLA+yaDaamEZuTfZ0Os4OCcwlYoGO7h
    sAKZHEIsqFkE1zb61kXyLyEqacyGu+m0hPpuHMeIS41Cp6+A6TkH2b7vFhy9/RCrO4Xsb9GMskC9
    sfyq8/q+kOr3YYiJVHlAhjalZz8DDnIITGRLf19DNLAD+ngfQqmDAKqZN2RCrEw8AJvZPnHjN3eF
    R6tmkWdQbWAUWA7nQuz1YH8X846KIVZ8yOL8LOt7Lrc+BhxVHuLiAbCTM0DROyhuwKvjXxZBQ4Bm
    MPpYhgvJNYW2A0ijUapMcuJ3QixLYYA3O7wXIMpYUe1V5FUkEyIPQX5OFFuGmboH530FUiOVCOUk
    x+6mGG61/ZwejzRW5TARtOLD7GAbACKuN8SCQblEfNeA0gIWgZH9ErCTjmDshVj0rwkWD0E1bSHW
    mk5qiRXgs2yE7AKmceriaUoo/EkTsBximXOSen+I+cQVwJAJR2BBoSpAMyVktVyE9zKb0ONLwH/Q
    3bMPMZrFvatimq5FPyj9IR3ABXOIQuyHRLXPxEuaEzbu+VDfQ3gsAUStIvB9COzzc6mUbpmQRaSy
    jGhBCxyIAXq5Gd44jIilEPuTD0vKnINd/g0uXYZzLpOI95pZEWxqTvoThE+G8AKidDbh3l2UZvWJ
    SDgDxcJoXhf2trWVrG3tMO0onIvus2SoRX+o75NeVym/GuobnJYT3M86b7ZB9H0l1Lfwsv27FGIT
    GTdlzUMNNaaqM8TqDr+ScvKvtEgLiDU519HtRZ0Q6jjSkBjWoCabdOidpgC4YXlLiLm42RD7h/ZC
    I6uAORn7fAmxKO/UE8noFRnxY+ADeTGUSZ1fm5r3FIgLiB0tyNnn5qvt+t4jBMty2KhhhH7owy57
    wvbqOYFjKcSWXW59+90QW2YeIIh2W2RZQQDOSRqfiDwvi9TbQn3GqOvgToRYxOBQ91trMrN0Lwfj
    vlw5PIRYEuusJrqrxWuDc35TYzlFvDrYnQWnpfPbFtOX4qpv6ffPhBooioFMwl3j+nhdwF03Aerg
    yhJ7CMteh05fTYRynUrg6sYjIbYLLUCzagagzjUNNmgP2+68Io67DH2WDCMjb4Xr5mQ18WXYnq7W
    PSJmshVijWh34HLHWteadc5EF2ARpYTszUKeW4sbQBKInXbHOn62x40KdCJpii4eJ1O632hbQh5X
    YU05B8LovdkQk6jfhJgx6e1D/3VB3tkQ09uZnHUUYr0uJ2UFIIE6YEAswiZexVHsgIzfR5zp1KdF
    r0Y2ITuTfU8q8Dc5dd3tNf9E3sgqNKEjKPzGRTpNNwV0fCdI1zVFnoRY8X8bRn4/7HgndbpJ5B6g
    D/2IOh4zjyEN2L/DKiUE2gIySNpwXszJD8SJ34bVQ8PDzHFZMKSS5O8otLw0vnsxxELeOwCOO4PV
    XXQtZ50xbinjunxzmHig8WB0uTNLWsAMrAbmgX9KIdro1l/XEzpzKuGr3pAkmIcXpNDAcHEu/6g4
    dUnPP5JV9Qtx/bfhanLG6hHs+SMw29Nj5ZUPGki/VL4egEMqMAKsMh6BKoaEAhhGQDwNE21fZFYV
    FzfiNST4QzXx73TCJi+BeeZhYBxBA6TRUw0xU33FKjGZVgkPWIaWsw/n9yAQ6e2I81Sg+2ag6z4W
    Obo2iF1GrnRYSdiwWUAQ2xLAMqcPOH0vD2DqERaJsS3nI7fZt27d1M7tMYC5txHK2NFA7e9tBr6r
    CaAV+6+WEUU4CDF7LQc4YwoJJswh3IPLNgV0gYv8NYtx7QC03gcZHxL29n6I/cePs1AyrJ45C/xc
    iD0XDkN9xfBeaE4UX45EOEHLOY3OY+qCfbsK0dYM5WQTBj/BcffFtV/Ve1dCbBXW3sBFXALs4t+K
    f1SyuDGFCRP+ExpEHSiffc+cVtGdQC6Cg29C3XPEwknUBn7n4OtuhRPQoNFF8Zfvh1jHsg34jSTw
    3GavQ6uVkPAnV8EQMi+JMTX6ceWjT0X21sYGgL2gjWvMlXOVn2jgNh33IdfdqdpJG65P+yDEhhtH
    4Pgssr0HSqlD0x5j8O6s0Rte0uw04exzDa7/SYN6VRPug06bgTxOaTddsckp9gGOQfuu/2mILYlK
    yHOwcfAQmA8rQgv6+1CIyV8v0Le1WjzsxsNCnY+1G40K7yX9RzbwVzSRD0Wi+Zd4TAI0oqwG3gF+
    UARKoB12uA2RPKBRqUSodCXElMEc/OGGJp6WlzrCBDZDbHddSjjqkyGUFBSW96UoXARO0iIi6T3x
    rrpcRS+QdHbYvw4M5o64bHeI+fydCb7i49ID54A7AtmtW6dpeQLu3myw5xB04kpCzqWxy4OwO71D
    bSG2B2tN8IoFXe+H+sKdrqDWCgylU3SuJI5fcvHpiC/DV/4iBsZaPHl8aUNniLBhFhNqhVslix3s
    1NnvCLECYRbh1mMsWBs+Syd4gXGT9p4cw+IhYq8a6pM7sg2CB24GWRecy8ILmQbs3xEClmZcgczr
    Ar4yg0m4H2IbIo6GQlTx8ipUTucRF7W7Z2A9rUJT6wuxkFEOLqfwkmPXDEvvGzkPZirnEbAmo2lF
    3NUTbA71hX5c3aEKZ/hCiOm1RwiGrcge/imgC1YNx4Fod+3ogs73PUx+NNQXPkgCcSwZam6om+TS
    nbA2MgnoIWO0nS/h1q7RMYyYURVytQUBLYsPexrvihKK4MiXgRaoaVcfSf62hNhPoivE9F8D4ppx
    VPZwXP5MQfTTHZ6WzBuBiOkKMUEq/VtALxnEmrIJ5E9rIvwS4IdqVgDcEzGzG4YK6vT5tHxmi3D2
    mXdclZfFrX1dStKFE9z26FQsuSa7PXuGDZ2H8z37W7BcVYi3DHhC+iUBbpepmJTYWNegarv1QYj5
    TwWJKJePPYug20bCMttCCoM7CbxoFZ7s5HGMeO92Iq+gBfiNJpy1ZMTC+nJHwmpJooJS+Mz5SK0h
    ds8ZB6r9ALb4tRDbdLtOxzZ0hU7gQvYgklpCgwZTdqz1AtPoc5mGAyz1LfAm19dpS9xTAVgtDRzJ
    IXhFBVgvB713Qqwj8J6ojc6BLiDoKZ4cmWC+Uj7ZjWcMuvMOQh8DDYyIzLec40xCQaniKkM8eNeG
    4TtrD7H4oNXGVTgdUi8RQdVEmDQAgeCuHt/oMP3PdTba4LzO/Q7MKvkc91pqhajLJGR9Fbr0FX0+
    F+obr9rW3dBm5HHEsgld3hGLFMTbIfDZh6FBR61RxISacQZT/4AJOzfI8KT8t+BGbLt2aFA/h5dl
    Bbp4RQvzU31vQhIlCy/IfmLXn2JOJcjkugm3wrd0DIM6qWd/2wI4GFcNsRzyyyjESsWCbOg7CLRZ
    Ph/oObXF+3NNbAJu3VbI3RIc/e77ZgaYDQ3a8S4gQGYvn9VGlzntwAuqCbB4M1yjRSjvSedCCLEQ
    kcvJ2N/1QYgFPa3GugPfD0PMFnfNSnpEd2ETGIrRCt/ZN8TSrHy9b4txuMJJcwJBm0KEvqiFyOO8
    toXY0dJJzgW4db8MsZ6AC/W6ivBQiNms+wigtcmiMtpnG7Lck50LsUaBy0T/TM+bTrimTkWDU1rz
    0GKyMCCOgG9k1nUGaJnREFuWLIRY+aj2nFrB+/8QYjuj6zBBXaM2WY04DZlvZ0B3qK+f9TWC5Uby
    9YeYX9zTiLs2A1vVjpgNETfb8O/mE2LIcaSzcNgzO/s38nkZUX9GgzrQZKf0/7Mh9jB0Kq5jVwyg
    WSLM6t1TgCr1a1HOwlPSmpxwEr6QaoDvIK7jCAtSCvUJUq3wER9oop9rp38Q6hvSPNYOu8mj8ZH2
    ga0BJ30IhL1J2vnHLj85Caabh48snVQ85hBNTyWUhwBzsAJySgPJU4Y2ZQZlcIorRIwCm+G2Qyv6
    zHiMI4BVe8EvWD75EOMsQ7FohygkTnsLvOjY5uG/CzFp0oZ5KnwzM7uRMWC2fwgl3paTe6vkwGA6
    dM/dEKsxGKfxUIufA+ilmjBM3FV+BH7pgMghF8OFyN6TLH/EHa4mXLXZUF8BOPwWEKpTzl0OuQt+
    LNa3TEte/4VIcEAG+n0xtaehviQGLSyX0LikhZqAQ4GVEqvQpYdEYZdOdncmGUwL2Nl/iJZl9+4S
    JpVt8Ezf95mgvLNa9Rshll7d+5b33AsxHd61tez0T5a7aII+vULNr1HS1e+6s57AEw36Y2k5Uw0w
    kG7yWAvF/BvBju+AnItUDl7ys3OyS1+LTMeli7vWwDQiimUE+VLJuFP2JTZrCN+e3rOLCfxIZGkE
    nU1L/jjt/pZ21rCE8DtMNA4slSqeTPoxopN2ItYW+T/RQriKeBpqaOplO+yJumN88SXv5gSegMsb
    ntD+kgXa/YdM8CWTfkFZJxO/lyD3u5qcvaGWNOf43mSZxx3tQE1Z+MsQS8OF33ECNbK7/S0D/f/s
    p8F7bzX6+8nn80lwqfFMX2uyPwoRtl/8HV/4jzax/5cLwM8PTyZ92smj5qx9SwxkAnHevf+/Bv6P
    /WMTrqgzcMqsHIv5x9iJf6xn/y4UkA2xBQH9QyXAG+ifsq5qe7g5YWhQD/dzSnS1nEx2F9aN1clW
    eCrLDTYkBUOnKRGvSiVU3irGaB3/4OS9Nco9/L8FGABXPFRENH6qkAAAAABJRU5ErkJggg=="
                    transform="matrix(0 0.5 -0.5 0 160 0)"
                />
            </g>
            <g style={{ opacity: 0.502, clipPath: 'url(#SVGID_2_)' }}>
                <image
                    style={{ overflow: 'visible' }}
                    width="58"
                    height="315"
                    id="Calque_2_1_"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAE7CAYAAACMkJI5AAAACXBIWXMAAAsSAAALEgHS3X78AAAA
    GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2hJREFUeNrs3D1v00AYwHHbREKo
    ZurE0jLDxAdgQux059sBM93ZYEVi4WVOJ5ZOTYWKhMxZnJFrnBdKCuTx7y89stPayf393J3v4thF
    cZmyCMqN3nqd4k6Kbym+RhOtepk8THGUl2VU0S6jB3lZRBYN3UarYiIQJUqUKNF/KdpMQXSR4iQv
    Q1PncW49hapsCGg+aj5qPmo+qjMiSpQoUaJEiRIlSpQoUaJEiRIlSpQoUaJEi6Df1g9Fw15/qQaZ
    DHtFbTaS0b3oGZ1UG53c6aWcgmjInnfsinfInneyGZ1UGzWoJ0qUKFGiRIkSJUqUKFGiRIkSJUqU
    aCDRZgqiIe/1Hrtrf57iZV42MqqN6nWJEiVKlChRokR3TzTk47hmIwP60yLg47hmI1O0V9GmaGNV
    N+wD1ibTRp1eiBLdLVHP7oyEZ3cCwHX3NzcCn0EuPUK3CprJX247qwJn9NJtZ1Xg9llGH9SP3kQ4
    C9w+9/tZnQXOaPiqOzpmr6YyoK9WNeBoouGfUT+5jE6qjYaHKFGiuyPaTEE0/Lf0s+Lyr65Pi+A/
    1mgzeV5M5CLTJNqo00uESXdE0aWzsCpYJpfOq2VUG9XrEiVK9M9oxoa00US76ebn4bQz2qX9L8WP
    y/m3UhyneJviImpG5zmj835GtVG9LlGiRIkSJbrsXBpa1E0QEXETBAAAAAAAAAAAAAAAAAAAAAAA
    AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwNUod6yMzS6KbvLZdYrDFHspzlPMUyyuIl1e
    U+GbNf/vBOo179duc5TiIMVJipc92d+S3qbo7VywIhfibIVcJ3C45j33evucDySXSY+Kl1vKfCv5
    MMXT/Pp5ijf5A4dyBxtmtBM4H1ThYiDXLo/zsv+/s00EypF2Uq84Ynez5MP8+k2WbXnS238/xWku
    /Dq6rJ3kgzOsAcuqa7v9sxSv+7KzFR1AnYUPe4UdHukmb9Me6ZspPuVt2vXHeX2/t9/HXpVbRz9r
    71N8WFIDuvLdz+v3epn/KVuOZLK/Y1vIi7ysB0d6vqZ6NyN/H2tPq2g2qH1dYu73mkZXzme5dp2V
    a3Z8kOJdrg5XLeyqwm+ztx92do9yOV+0y3LNjl2bWvyFwm7z9FYPMrv40972fx9R/Sz/dwEGAGAE
    sP2K4aG1AAAAAElFTkSuQmCC"
                    transform="matrix(0 0.5 -0.5 0 158.5 0.5)"
                />
            </g>
        </g>
    </svg>
);

Plaster.propTypes = propTypes;
Plaster.defaultProps = defaultProps;

export default Plaster;
